import {Button, CalendarBar, RadioGroup, TextInput} from "omoplay";
import SuspensePopup from "../../SuspensePopup";
import React, {useEffect, useState} from "react";
import BenefitForm from "../benefit/BenefitForm";
import {getBenefit} from "../../../api/benefit/benefit.api";
import moment from "moment";
import {URL_SCHEME_REGEX} from "../../../libs/urlValidator";


const ButtonsForm = ({ maxLength, buttons, coupon, onChangeButtons, onChangeCoupon, isConnect = false, required = false, isAuto = false}) => {
    const [openBenefitPopup, setOpenBenefitPopup] = useState(null)
    const [benefitName, setBenefitName] = useState("")
    const [buttonTypes, setButtonTypes] = useState([required ? "WL" : "", ""])
    const [couponType, setCouponType] = useState(coupon ? (coupon.benefitId ? "COUPON" : "WL") : "")

    const items = [
        {
            label: "링크",
            value: "WL"
        }
    ]

    useEffect(() => {
        if (isConnect) {
            const benefitId = coupon?.benefitId
            if (benefitId !== undefined && !isNaN(Number(benefitId))) {
                getBenefit(benefitId).then(({data}) => {
                    setBenefitName(data.name)
                })
            }
        }
    }, [buttons])

    useEffect(() => {
        if (required && buttons === undefined) {
            onChangeButtons(0, "type", "WL")
        }
        if (buttons?.length > 0 && buttons[0] != null) {
            setButtonTypes([buttons[0].type ?? (required ? "WL" : ""), buttons?.length === 2 ? buttons[1].type : ""])
        }
        setCouponType(coupon ? ((couponType === "COUPON" || coupon.benefitId) ? "COUPON" : "WL") : "")
    }, [coupon, buttons, required]);

    const openUrl = (url) => {
        window.open(url)
    }

    return (
        <>
            {Array.from({ length: maxLength }, (_, index) => {
                const button = (buttons ?? [])[index] ?? {}
                const type = buttonTypes[index]
                const inItems = [...items]

                if (!required || index > 0) {
                    inItems.unshift(
                        {
                            label: "없음",
                            value: "",
                        }
                    )
                }

                return (
                    <div className="flex-col gap-2">
                        <div className="font-semibold">버튼 {index + 1}</div>
                        <RadioGroup
                            key={buttonTypes[index]}
                            items={inItems}
                            initChecked={buttonTypes[index]}
                            value={type}
                            onSelected={(value) => {
                                onChangeButtons(index, "type", value)
                                setButtonTypes((prev) => {
                                    prev[index] = value
                                    return prev
                                })
                            }}
                        />
                        {type === "WL" && (
                            <div className="flex-col gap-2">
                                <TextInput
                                    placeholder="버튼명을 입력해 주세요."
                                    maxLength={8}
                                    value={button.name ?? ""}
                                    onChange={(e) => onChangeButtons(index, "name", e.target.value)}
                                />
                                <div className="flex gap-2">
                                    <div className="w-full flex-1">
                                        <TextInput
                                            placeholder="연결할 페이지의 URL을 입력해주세요."
                                            value={button.urlMobile ?? ""}
                                            onChange={(e) =>
                                                onChangeButtons(index, "urlMobile", e.target.value)
                                            }
                                        />
                                    </div>
                                    <Button
                                        variants="dark"
                                        onClick={() => openUrl(button.urlMobile)}
                                        value="URL 확인"
                                    />
                                </div>
                                {
                                    (button.urlMobile?.length > 0 && !URL_SCHEME_REGEX.test(button.urlMobile)) && (<div className="text-red-500">버튼 url은 http:// 또는 https:// 로 시작하는 완전한 주소여야 합니다.</div>)
                                }
                                <div>PC 전용 링크</div>
                                <div className="flex gap-2">
                                    <div className="w-full flex-1">
                                        <TextInput
                                            placeholder="연결할 페이지의 URL을 입력해주세요."
                                            value={button.urlPc ?? ""}
                                            onChange={(e) =>
                                                onChangeButtons(index, "urlPc", e.target.value)
                                            }
                                        />
                                    </div>
                                    <Button
                                        variants="dark"
                                        onClick={() => openUrl(button.urlPc)}
                                        value="URL 확인"
                                    />
                                </div>
                                {
                                    (button.urlPc?.length > 0 && !URL_SCHEME_REGEX.test(button.urlPc)) && (<div className="text-red-500">버튼 url은 http:// 또는 https:// 로 시작하는 완전한 주소여야 합니다.</div>)
                                }
                            </div>
                        )}
                    </div>
                );
            })}
            <div className="flex-col gap-2 mb-2">
                <div className="font-semibold">쿠폰</div>
                <RadioGroup
                    key={couponType}
                    items={[
                        {
                            label: "없음",
                            value: "",
                        },{
                            label: "쿠폰",
                            value: "COUPON"
                        },{
                            label: "링크",
                            value: "WL"
                        }
                    ]}
                    initChecked={couponType}
                    value={couponType}
                    onSelected={(value) => {
                        if (value === "COUPON") {
                            if (isAuto) {
                                onChangeCoupon("benefitExpiredDay", coupon?.benefitExpiredDay ?? 7)
                            } else {
                                const expiredDate = coupon?.benefitExpiredDate ? moment(coupon.benefitExpiredDate, "YYYY-MM-DD") : moment().add(7, "days").format("YYYY-MM-DD")
                                onChangeCoupon("benefitExpiredDate", expiredDate)
                            }
                        }
                        if (value === "") {
                            onChangeCoupon("type", "")
                        }
                        setCouponType(value)
                    }}
                />
                {couponType === "COUPON" && (
                    <div className="flex-col gap-2">
                        <TextInput
                            placeholder="쿠폰명을 입력해 주세요."
                            maxLength={7}
                            value={coupon?.title?.replace(" 무료 쿠폰", "") ?? ""}
                            onChange={(e) => onChangeCoupon("title", e.target.value)}
                        />
                        <TextInput
                            placeholder="쿠폰 설명을 입력해 주세요."
                            maxLength={12}
                            value={coupon?.description ?? ""}
                            onChange={(e) => onChangeCoupon("description", e.target.value)}
                        />
                        <div className="flex gap-2">
                            <div className="w-full flex-1">
                                <TextInput
                                    placeholder="연결할 혜택을 선택해주세요"
                                    value={benefitName}
                                    disabled={true}
                                    readOnly
                                />
                            </div>
                            <Button
                                variants="default"
                                value="혜택 연결하기"
                                onClick={() => setOpenBenefitPopup(0)}
                            />
                        </div>
                        {
                            isAuto ? (
                                <div className="flex-align-center gap-4">
                                    <div className="font-16px">혜택 만료일</div>
                                    <div>발급 시점으로부터</div>
                                    <TextInput className="max-w-[30px]" placeholder="일자"
                                               value={coupon?.benefitExpiredDay ?? 7}
                                               onChange={(e) => {
                                                   onChangeCoupon("benefitExpiredDay", e.target.value)
                                               }}
                                    />
                                    <div>일</div>
                                </div>
                            ) : (
                                <div className="flex-align-center gap-4">
                                    <div className="font-16px">혜택 만료일</div>
                                    <CalendarBar
                                        key={coupon?.benefitExpiredDate}
                                        multiple={false}
                                        initDate={{
                                         startDate: coupon?.benefitExpiredDate ? moment(coupon.benefitExpiredDate, "YYYY-MM-DD").toDate() : moment().add(7, "days").toDate(),
                                         endDate: coupon?.benefitExpiredDate ? moment(coupon.benefitExpiredDate, "YYYY-MM-DD").toDate() : moment().add(7, "days").toDate()
                                        }}
                                        minDate={new Date()}
                                        onConfirm={(dateProps) => {
                                         onChangeCoupon("benefitExpiredDate", moment(dateProps.startDate).format("YYYY-MM-DD"))
                                        }}
                                    />
                                </div>
                            )
                        }
                    </div>
                )}
                {couponType === "WL" && (
                    <div className="flex-col gap-2">
                        <TextInput
                            placeholder="쿠폰명을 입력해 주세요."
                            maxLength={7}
                            value={coupon?.title?.replace(" 무료 쿠폰", "") ?? ""}
                            onChange={(e) => onChangeCoupon("title", e.target.value)}
                        />
                        <TextInput
                            placeholder="쿠폰 설명을 입력해 주세요."
                            maxLength={12}
                            value={coupon?.description ?? ""}
                            onChange={(e) => onChangeCoupon("description", e.target.value)}
                        />
                        <div className="flex gap-2">
                            <div className="w-full flex-1">
                                <TextInput
                                    placeholder="연결할 페이지의 URL을 입력해주세요."
                                    value={coupon?.urlMobile ?? ""}
                                    onChange={(e) =>
                                        onChangeCoupon("urlMobile", e.target.value)
                                    }
                                />
                            </div>
                            <Button
                                variants="dark"
                                onClick={() => openUrl(coupon?.urlMobile)}
                                value="URL 확인"
                            />
                        </div>
                        {
                            (coupon?.urlMobile?.length > 0 && !URL_SCHEME_REGEX.test(coupon?.urlMobile)) && (<div className="text-red-500">버튼 url은 http:// 또는 https:// 로 시작하는 완전한 주소여야 합니다.</div>)
                        }
                    </div>
                )}
            </div>

            <SuspensePopup
                title={"혜택 연결하기"}
                style={{width: "960px"}}
                visible={openBenefitPopup !== null}
                onClose={() => setOpenBenefitPopup(null)}
            >
                <BenefitForm
                    onSelectedBenefit={(benefitId, benefitName) => {
                        onChangeCoupon("benefitId", benefitId)
                        setBenefitName(benefitName)
                        setOpenBenefitPopup(null)
                    }}
                />
            </SuspensePopup>
        </>
    )
}

export default ButtonsForm